import { render } from "./NSigningRoom.vue?vue&type=template&id=70d5f219&scoped=true"
import script from "./NSigningRoom.vue?vue&type=script&lang=js"
export * from "./NSigningRoom.vue?vue&type=script&lang=js"

import "./NSigningRoom.vue?vue&type=style&index=0&id=70d5f219&lang=css"
import "./NSigningRoom.vue?vue&type=style&index=1&id=70d5f219&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d5f219"]])

export default __exports__